import { el } from './dom.js';

/* --------------------------------------------------------------------------
   Urval var som helst på sidan

   På smal skärm, där sidomenyn inte får plats, står knappen Urval i
   flikraden, som står kvar överst när man rullar. Den visar vald period. Ett klick öppnar urvalet som en ruta under raden, där man är,
   i stället för att man ska rulla upp till toppen. Ändringarna gäller direkt;
   innehållet bakom ritas om medan rutan är öppen.

   Det är samma urval, inte en kopia: elementet .controls flyttas in i rutan
   och tillbaka till sidomenyn när den stängs, med alla händelser och värden
   kvar. Blir fönstret så brett att sidomenyn syns stängs rutan.

   Rutan stängs med Klar, Escape, ett klick utanför eller knappen igen.
   Escape stänger först en öppen lista eller kalender i rutan, sedan rutan.
   -------------------------------------------------------------------------- */

let spot = null;   // platshållaren där urvalet står annars

export const quickFilterOpen = () => !el('filterPop').hidden;

/** Samma gräns som i styles.css, där sidomenyn visas. */
const sidebarShown = () => typeof matchMedia === 'function' && matchMedia('(min-width: 1100px)').matches;

/** Rullar rutan själv bara när den inte ryms på skärmen. */
function fit(){
  const pop = el('filterPop');
  if(pop.hidden) return;
  // Brett nog för sidomenyn: urvalet hör hemma där
  if(sidebarShown()){ closeQuickFilter(); return; }
  pop.classList.remove('is-tall');
  pop.style.maxHeight = '';
  const room = window.innerHeight - pop.getBoundingClientRect().top - 8;
  if(pop.offsetHeight > room){
    pop.classList.add('is-tall');
    pop.style.maxHeight = Math.max(200, room) + 'px';
  }
}

function open(){
  const controls = el('controls'), pop = el('filterPop');
  spot = document.createElement('div');
  spot.className = 'controls-spot';
  controls.replaceWith(spot);
  pop.prepend(controls);
  pop.hidden = false;
  fit();
  el('btnQuickFilter').setAttribute('aria-expanded', 'true');
  // Fokus till det valda tidsalternativet, där man oftast vill börja
  (controls.querySelector('#controlsGrid input[type=radio]:checked') ||
   controls.querySelector('#controlsGrid input, #controlsGrid select'))?.focus({preventScroll: true});
}

export function closeQuickFilter(returnFocus = false){
  if(!quickFilterOpen()) return;
  const controls = el('controls');
  spot.replaceWith(controls);
  spot = null;
  el('filterPop').hidden = true;
  el('btnQuickFilter').setAttribute('aria-expanded', 'false');
  if(returnFocus) el('btnQuickFilter').focus({preventScroll: true});
}

/** Vald period på knappen, så att den syns även långt ner på sidan. */
export function syncQuickFilter(){
  el('quickFilterNow').textContent = el('tagTime').textContent;
}

/** Är det en öppen lista, kalender eller förklaring som Escape eller ett klick hör till? */
const innerPopupOpen = () =>
  !!document.querySelector('.ms-panel:not([hidden]), .cal:not([hidden]), .help-pop');

/** Tonar ut flikradens högra kant när flikarna inte ryms och kan rullas i sidled. */
function watchTabOverflow(){
  const nav = document.querySelector('nav.tabs');
  const sync = () => {
    nav.classList.toggle('is-scrollable', nav.scrollWidth > nav.clientWidth + 1);
    nav.classList.toggle('at-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1);
  };
  nav.addEventListener('scroll', sync, {passive: true});
  if(typeof ResizeObserver === 'function') new ResizeObserver(sync).observe(nav);
  sync();
}

export function initQuickFilter(){
  watchTabOverflow();
  window.addEventListener('resize', fit);
  el('btnQuickFilter').addEventListener('click', () => quickFilterOpen() ? closeQuickFilter(true) : open());
  el('btnFilterDone').addEventListener('click', () => closeQuickFilter(true));
  // Fångas före listornas egna lyssnare, som stänger sig själva
  document.addEventListener('keydown', e => {
    if(e.key === 'Escape' && quickFilterOpen() && !innerPopupOpen()) closeQuickFilter(true);
  }, true);
  document.addEventListener('pointerdown', e => {
    if(!quickFilterOpen()) return;
    const t = e.target;
    if(t.closest('#filterPop, #btnQuickFilter, .cal, .help-pop')) return;
    closeQuickFilter(false);
  });
}
